import baseAPI from '@/api';
import { BettingSessionTimePlayedInputDto } from '@/services/dto/betiing-session/betting-session-time-played-input.dto';

export async function fetchBettingSessionTimePlayed(
  data: BettingSessionTimePlayedInputDto,
): Promise<void> {
  await baseAPI.patch(`/betting-sessions/${data.sessionId}/time-played`);
}
